const messagesDE = {
    code: "de",
    messages: {
        alpha: (field) => `${field} darf nur Buchstaben enthalten`,
        alpha_dash: (field) => `${field} Das Feld kann Buchstaben und Bindestriche (-) oder Unterstriche (_) enthalten.`,
        alpha_num: (field) => `${field} darf nur Buchstaben und Zahlen enthalten`,
        alpha_spaces: (field) => `${field} Nur Buchstaben dürfen Leerzeichen enthalten`,
        between: (field, min, max) => `${field} ${min} mit ${max} sollte im Bereich liegen`,
        confirmed: (field) => `${field} Die Überprüfung ist falsch`,
        digits: (field, length) => `${field} numerische und ${length} sollte gestuft werden`,
        dimensions: (field, width, height) => `${field} Bereich ${width} mit Pixel ${height} sollte zwischen Pixeln liegen`,
        email: (field) => `${field} Das Feld muss eine gültige E-Mail-Adresse sein`,
        excluded: (field) => `${field} Geben Sie einen gültigen Wert in das Feld ein`,
        ext: (field) => `${field} Das Feld muss eine gültige Datei sein`,
        image: (field) => `${field} Das Feld muss eine Bilddatei sein`,
        oneOf: (field) => `${field} Geben Sie einen gültigen Wert in das Feld ein`,
        max: (field, length) => `${field} Bereich ${length} nicht mehr als ein Zeichen`,
        max_value: (field, max) => `${field} Bereich ${max} oder weniger`,
        mimes: (field) => `${field} muss eine gültige Datei sein`,
        min: (field, length) => `${field} Bereich zumindest ${length} Es muss ein Zeichen eingegeben werden`,
        min_value: (field, min) => `${field} Bereich ${min} muss einen Wert von oder mehr haben`,
        numeric: (field) => `${field} Geben Sie einen numerischen Wert in das Feld ein`,
        regex: (field) => `${field} Format ist ungültig`,
        required: (field) => `${field} alanı gereklidir`,
        required_if: (field) => `${field} Platz ist erforderlich`,
        size: (field, size) => `${field} Bereich ${size} Sollte kleiner als KB sein`,
    },
};

export default messagesDE;



// WEBPACK FOOTER //
// ./src/language/validationMessagesDE.js